module.exports = __webpack_public_path__ + "img/layout_fish_right.32b8a944.svg";